module.exports = __webpack_public_path__ + "img/stageSection01.491202e6.png";